import React, { PropsWithChildren, useMemo, useState } from 'react';
import { Drawer } from '@economic/taco';
import { HelpDrawerContext, HelpDrawerState } from '~/app/components/Header/Help/HelpDrawerContext';
import { HelpOverview } from '~/app/components/Header/Help/overview/HelpOverview';
import { DRAWERS } from '~/app/shared/drawers';
import * as inapphelpMixpanel from '~/app/components/Header/Help/tracking';

export function HelpDrawer({ children }: PropsWithChildren<unknown>): React.JSX.Element {
    const [activeView, setActiveView] = useState<React.JSX.Element | null>(null);

    const helpContext = useMemo<HelpDrawerState>(() => {
        return {
            navigate(view) {
                setActiveView(view);
            },
            back() {
                setActiveView(null);
            },
        };
    }, []);

    return (
        <HelpDrawerContext.Provider value={helpContext}>
            <Drawer
                variant="embedded"
                outletName={DRAWERS.app}
                onClose={() => setActiveView(null)}
                onChange={open => inapphelpMixpanel.trackDrawerToggle({ action: open ? 'open' : 'close' })}>
                <Drawer.Trigger>{children}</Drawer.Trigger>
                <Drawer.Content aria-label="">{activeView ?? <HelpOverview />}</Drawer.Content>
            </Drawer>
        </HelpDrawerContext.Provider>
    );
}
